import { useEffect, useState } from "react";
import { useGetSummary } from "../../../utils/getSummary";
export var useSummaryFilters = function () {
    var summary = useGetSummary();
    var _a = useState([]), filters = _a[0], setFilters = _a[1];
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFilters(newMap || []);
    }, [summary]);
    return { filters: filters };
};
